import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "73",
  height: "12",
  viewBox: "0 0 73 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M14.773 0c.96 0 1.74.78 1.74 1.741v10.14h-3.48V9.726h-2.515a5.94 5.94 0 1 1 0-7.568h2.514V1.74A1.74 1.74 0 0 1 14.772 0Zm9.526.001a2.619 2.619 0 0 1 2.618 2.62v9.26h-3.482v-7.7a.698.698 0 0 0-.698-.699h-3.483a1.741 1.741 0 0 1 0-3.481h5.045ZM29.657 0c.961 0 1.741.78 1.741 1.74v10.14h-3.481V1.74c0-.96.78-1.74 1.74-1.74Zm17.189 0c.96 0 1.74.78 1.74 1.74v10.14h-3.481V7.767h-1.113a5.94 5.94 0 1 1 .05-3.481h1.063V1.74c0-.96.78-1.74 1.74-1.74Zm12.09 3.482H58V8.4h.934v3.482h-6.73a2.62 2.62 0 0 1-2.616-2.488l-.003-.13V2.62A2.619 2.619 0 0 1 52.074.005l.13-.004h6.731v3.481Zm5.07-3.475a4.072 4.072 0 0 1 4.071 4.071v7.803h-3.481V4.077a.59.59 0 0 0-1.179 0v7.804h-3.482V4.078a4.071 4.071 0 0 1 4.07-4.071Zm6.83 8.353a1.76 1.76 0 1 1 0 3.522 1.76 1.76 0 0 1 0-3.522ZM5.939 3.327a2.614 2.614 0 1 0 .002 5.228 2.614 2.614 0 0 0-.002-5.228Zm32.399 0a2.614 2.614 0 1 0 0 5.227 2.614 2.614 0 0 0 0-5.227Zm15.436.156a.698.698 0 0 0-.694.622l-.004.077v3.52c0 .36.272.657.622.694l.076.004h1.11V3.483h-1.11ZM11.828 5.172c.033.252.052.508.052.77 0 .264-.02.525-.053.78h1.205v-1.55h-1.204Z",
      fill: "#C2C2C2"
    }, null, -1)
  ])))
}
export default { render: render }